export default __webpack_public_path__ + "static/fall2 (4)-46c36e8cd43335a6b2307e84283eabf0.jpg";